import CompanyAvatar from './CompanyAvatar';

export default CompanyAvatar;
